export const text =
`
This is the name of a fantasy novel I wrote when I was 13.  I'm considering releasing it on Royal Road.`